export default "__VITE_ASSET__Ci$jnLfp__"